/* eslint-disable no-undef */
//3rd Party Components
import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';
import { AUcallout } from '@gov.au/callout';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

//Components
import { addPageAlert } from '../../PortalStore/Actions/PageAlertActions';
import Heading from '../../components/CASA/Heading';
import { Html5QRScanner } from '../../components/Portal/TypeScript/Html5QRScanner/Html5QRScanner';

//Actions

export const VerificationScanPage = () => {

    const [launch, setLaunch] = useState(false);

    const history = useHistory();
    const dispatch = useDispatch();

    const openSubmissionPage = (passHash) => {

        //encoded params
        history.push(`/digitallicence/verification/submit?passHash=${encodeURIComponent(passHash)}`);

    };

    const onNewScanResult = (decodedText) => {
        // Handle the result here.
        if (decodedText) {
            const url = new URL(decodedText.data);

            if (url?.search) {
                const urlParams = new URLSearchParams(url.search);
                const passHash = urlParams.get('passHash');

                if (urlParams && passHash) {
                    setTimeout(openSubmissionPage, 2000, passHash);
                }
            }
            else {
                dispatch(addPageAlert({
                    level: 'error',
                    title: 'Unrecognised QR code',
                    message: 'This QR code is either invalid or is not a CASA produced QR code.'
                }));
            }
        }
        else {
            dispatch(addPageAlert({
                level: 'error',
                title: 'Failed to read QR code',
                message: 'Failed to read QR code, please make sure the QR is clearly visible in the photo.'
            }));
        }
    };

    const launchClick = () => {
        setLaunch(true);
    }

    return (
        <>

            <Heading
                text="Confirm details of a digital licence"
                breadcrumbs={[
                    { text: 'myCASA', link: '/dashind' },
                    { text: 'Confirm details of a digital licence' }
                ]}
                showback={true} />

            <Row noGutters>
                <Col lg={6} md={6} className='float-none'>
                    <AUcallout
                        title=""
                        srOnlyTitle>
                        <p>To confirm the details of a digital Flight Crew Licence or Remote Pilot Licence (RePL), you'll need to scan the QR code on the licence.</p>
                        <p>You can learn more about licence confirmation and how to scan QR codes on the <a href="https://www.casa.gov.au/qr-code-verification" target="_blank">CASA website</a>.</p>
                    </AUcallout>
                </Col>
            </Row>            
            
            {launch ?
                <Html5QRScanner qrCodeSuccessCallback={onNewScanResult} />
                :
                <div className='au-form-group'>
                    <a className='au-btn' onClick={() => launchClick()}>Launch camera</a>
                </div>
            }
            

        </>
    );
};